import classnames from 'classnames';
import React from 'react';
import { Input, Label } from 'reactstrap';

type Props = {
  label?: string;
  handle?: string;
  disabled?: boolean;
  className?: string;
  checked?: boolean;
  [key: string]: any;
};

const Switch = ({
  label = '',
  handle = '',
  disabled,
  className,
  checked,
  ...props
}: Props) => {
  const classList = classnames(
    'switch switch-default switch-pill switch-lg',
    className,
    {
      'switch--disabled': disabled,
    },
  );
  const labelClassName = classnames('switch-label', {
    'switch-label--disabled': disabled,
  });
  const handleClassName = classnames('switch-handle', {
    'switch-handle--disabled': disabled,
  });
  const defaultLabel = checked ? 'ON' : 'OFF';

  return (
    <Label className={classList}>
      <Input
        type="checkbox"
        className="switch-input"
        disabled={disabled}
        checked={checked}
        {...props}
      />
      <span className={labelClassName}>{label ? label : defaultLabel}</span>
      <span className={handleClassName}>{handle}</span>
    </Label>
  );
};

export default Switch;
